import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { Tooltip } from '@mui/material'

import useAuthorizationsById from '../../../hooks/useAuthorizations/useAuthorizationsById'
import { RepairOrderExpanded } from '../../../sdk'
import { checkIsEqualForTwoDecimal } from '../../../utils/checkIsEqualForTwoDecimal/checkIsEqualForTwoDecimal'

export const authorizationWarningCheck = (
  previousTotal: number | undefined,
  repairOrder: RepairOrderExpanded | null
) => {
  if (previousTotal === null || repairOrder === null) {
    return null
  }
  const repairOrderPricing = repairOrder.entry!.info!.isEstimate
    ? repairOrder.totalPricing
    : repairOrder.authorizedPricing
  const estimateTotal = repairOrderPricing?.total || 0
  if (
    previousTotal &&
    !checkIsEqualForTwoDecimal(previousTotal, estimateTotal) &&
    previousTotal < estimateTotal
  ) {
    return {
      passes: false,
      message: 'Repair Order Total is greater than latest authorization'
    }
  }
  return {
    passes: true,
    message: ''
  }
}

export const AuthorizationWarning = ({
  repairOrder
}: {
  repairOrder: RepairOrderExpanded
}) => {
  const { previousTotal } = useAuthorizationsById(repairOrder.entry!.id!)

  const checkResult = authorizationWarningCheck(previousTotal!, repairOrder)
  return (
    <>
      {checkResult && !checkResult.passes && (
        <Tooltip title={checkResult.message} placement="top-start">
          <WarningAmberIcon color="warning" sx={{ pr: 1 }} />
        </Tooltip>
      )}
    </>
  )
}
